import logo from "assets/logo.svg";
import { useState, useEffect } from "react";
import { FiArrowLeft, FiMenu, FiHelpCircle, FiChevronDown } from "react-icons/fi";
import { Link } from "react-router-dom";
import SideMenu from "./SideMenu";
import UserMenu from "./UserMenu";
import DateTime from "./DateTime";
import { Tooltip } from 'react-tooltip';
import { useOrganization } from "hooks/OrganizationContext";
import { profileOrganization } from "api/organizations";

export default function Header() {
  const [showSideMenu, setShowMenu] = useState(false);
  const [showOrgDropdown, setShowOrgDropdown] = useState(false);
  // const [organizations, setOrganizations] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const { selectedOrganization, setSelectedOrganization, organizations, setOrganizations } = useOrganization();
  
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        setLoading(true);
        const response = await profileOrganization();
    
        if (response.status === 200 && response.data.list.length > 0) {
          setOrganizations(response.data.list);
          // Set the first organization as default if none is selected
          if (!selectedOrganization.id) {
            setSelectedOrganization(response.data.list[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching organizations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  return (
    <div className="w-full bg-dark relative z-40">
      <div className="mx-auto max-w-screen-3xl flex items-center h-16 px-3">
        <div className="relative z-50 flex items-center gap-5">
          <div
            onClick={() => setShowMenu(!showSideMenu)}
            className="cursor-pointer duration-300"
          >
            {!showSideMenu && <FiMenu size="30" />}
            {showSideMenu && <FiArrowLeft size="30" />}
          </div>
          <Link to="/">
            <img src={logo} className="h-8" alt="logo" />
          </Link>
          {organizations.length > 0 && (
            <div className="relative ">
              <button
                onClick={() => setShowOrgDropdown(!showOrgDropdown)}
                className="flex items-center gap-2 px-3 py-1 text-sm text-gray-400 hover:text-white bg-[#1A1A1A] rounded-lg border border-white/[0.08] hover:bg-[#2A2A2A]"
              >
                <span className="mt-1 text-base">{selectedOrganization.name || 'Select Organization'}</span>
                <FiChevronDown className="text-gray-400 mt-1" />
              </button>
              {showOrgDropdown && (
                <>
                  <div
                    className="fixed inset-0 z-10"
                    onClick={() => setShowOrgDropdown(false)}
                  />
                  <div className="absolute left-0 mt-2 w-64 bg-[#1A1A1A] rounded-lg border border-white/[0.08] shadow-lg z-20">
                    {organizations.map((org: any) => (
                      <button
                        key={org.id}
                        onClick={() => {
                          setSelectedOrganization(org);
                          setShowOrgDropdown(false);
                        }}
                        className={`flex items-center w-full px-4 py-2 text-sm ${
                          selectedOrganization.id === org.id
                            ? 'text-white bg-white/[0.08]'
                            : 'text-gray-400 hover:bg-white/[0.08] hover:text-white'
                        }`}
                      >
                        {org.name}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-4">
         
        
          <DateTime />
          {/* <div className="mx-2">
            <Info />
          </div> */}
          
          <UserMenu />
        </div>
        <SideMenu
          closeMenu={() => setShowMenu(false)}
          showSideMenu={showSideMenu}
        />

        <Tooltip 
          id="help-tooltip"
          place="bottom"
          className="bg-[#1A1A1A] border border-white/[0.08] !opacity-100"
          style={{
            fontSize: '0.875rem',
            padding: '0.5rem 0.75rem'
          }}
        />
      </div>
    </div>
  );
}
